import React from 'react';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { FaHome } from "react-icons/fa";
import { useTranslation } from 'react-i18next'; // Add this import

function Navmenu() {
  const { t } = useTranslation(); // Get the translation function
  
  // Update link titles to use translation keys
  const links = [
    { id: 1, title: 'navigation.home', href: '/home', icon: <FaHome style={{ marginBottom: '5px', marginRight: '5px' }} /> },
    { id: 2, title: 'navigation.about', href: '/About', icon: null },
    { id: 3, title: 'navigation.contact', href: '/Contact', icon: null },
  ];

  const [hoveredLink, setHoveredLink] = useState(null);

  const linksItem = links.map((link) => (
    <div
      className={`link ${hoveredLink === link.id ? 'hovered' : ''}`}
      key={link.id}
      onMouseEnter={() => setHoveredLink(link.id)}
      onMouseLeave={() => setHoveredLink(null)}
      style={{ transform: `scale(${hoveredLink === link.id ? 1.1 : 1})` }}
    >
      <Link to={link.href}>
        {link.icon}
        {t(link.title)} {/* Use t() function to translate */}
      </Link>
      <div className="Navmenu-effect"></div>
    </div>
  ));

  return (
    <div>
      <div className="link-container">
        {linksItem}
      </div>
    </div>
  );
}

export default Navmenu;